import { useState, useEffect } from 'react'
import { Popup } from 'react-map-gl'
import "./PopupInfo.css"
import { format } from 'timeago.js'

const PopupInfo = ({ info }) => {
    const [display, setDisplay] = useState(info.display)
    const tTime = info.date.slice(11, 16)
    const tDay = info.date.slice(0, 10)
    const tAgo = format(info.date)
    useEffect(() => {
        const fetching = () => {

            setDisplay(true)
        }
        fetching()
    }, [info])

    return (
        <>
            {(display) && (
                <Popup
                    latitude={info.coord[1]}
                    longitude={info.coord[0]}
                    closeButton={true}
                    closeOnClick={false}
                    onClose={() => setDisplay(false)}
                    anchor="left"
                >
                    <div className="popupCard">
                        <label className="popupTitle"><b>{info.title}</b></label>
                        <label className="popupLabel"> Warning : Wildfire </label>
                        <label className="popupLabel">{`Date:  ${tTime}, ${tDay}`} <br /> &emsp;&emsp;&ensp; {`(${tAgo})`}</label>
                        <label className="popupLabel">COORD: {info.coord[0]} , {info.coord[1]}</label>
                        <p className="popupID">{info.id} </p>
                    </div>
                </Popup>
            )
            }
        </>
    )
}

export default PopupInfo
